import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import AsyncSelect from 'react-select/async'

import { selectActiveBuilding } from '../../../../reducers/buildingSelectorReducer'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'
import API from '../../../../api/api'

const MAX_PAGE_SIZE = 50

const SelectInspectionTemplate = ({
  onBack = () => {},
  onNext = () => {},
  onSelect = () => {},
  building,
  value,
}) => {
  const { t } = useTranslation(['internal-inspections', 'common'])
  const [pageNumber, setPageNumber] = useState(1)
  const [allOptionsLoaded, setAllOptionsLoaded] = useState(false)
  const { displaySnackbar } = useSnackbar()

  const fetchTemplates = async (search = '', callback = () => {}) => {
    if (allOptionsLoaded) return

    try {
      const skip = (pageNumber - 1) * MAX_PAGE_SIZE

      const result = await API.getInspectionTemplates(building.id, {
        skip,
        limit: MAX_PAGE_SIZE,
        search,
      })

      const options = result.data.data.map((template) => ({
        value: template.id,
        label: template.name,
      }))

      if (options.length < MAX_PAGE_SIZE) {
        setAllOptionsLoaded(true)
      } else {
        setPageNumber((prev) => prev + 1)
      }

      callback(options)
    } catch {
      displaySnackbar(t('internal-inspections:selectInspectionTemplate.errorFetching'), true)
      callback([])
    }
  }

  const loadOptions = (inputValue, callback) => {
    setPageNumber(1)
    setAllOptionsLoaded(false)
    fetchTemplates(inputValue, callback)
  }

  return (
    <React.Fragment>
      <div className="inspections-modal-content select-template">
        <span className="inspections-modal-title">
          {t('internal-inspections:selectInspectionTemplate.title')}
        </span>
        <AsyncSelect
          className="search-select-container"
          classNamePrefix="select-primary"
          placeholder={t('internal-inspections:toolbar.searchTemplatesPlaceholder')}
          defaultOptions
          loadOptions={loadOptions}
          onChange={(item) => onSelect(item)}
          value={value}
          isClearable
          cacheOptions
        />
      </div>
      <div className="inspections-modal-actions">
        <button onClick={onBack} className="button button-gray">
          {t('common:actions.back')}
        </button>
        <button className="button button-primary auto-width" onClick={onNext} disabled={!value}>
          {t('internal-inspections:shared.next')}
        </button>
      </div>
    </React.Fragment>
  )
}

SelectInspectionTemplate.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onSelect: PropTypes.func,
  value: PropTypes.object,
  building: PropTypes.object,
}

export default connect(
  (state) => ({
    building: selectActiveBuilding(state),
  }),
  null,
)(SelectInspectionTemplate)
